
export default function VideoSection() {
    return(
        <div>
            <iframe style={{display: 'block', margin: 'auto'}} width="560" height="315" src="https://youtube.com/embed/i3SjkUtPKHo" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        </div>
    );
}
